export const TID = {
  nav: {
    home: "nav-link-home",
    pricing: "nav-link-pricing",
    maintenance: "nav-link-maintenance",
    contact: "nav-link-contact",
    faq: "nav-link-faq",
    cta: "nav-cta-start",
    mobileToggle: "nav-mobile-toggle",
  },
  home: {
    heroCta: "hero-cta-packages",
    heroContact: "hero-cta-contact",
    heroPrice: "hero-price-from",
    marquee: "home-marquee",
    mini: (id) => `package-mini-${id}`,
    maintenanceBand: "home-maintenance-band",
    ctaBand: "home-cta-band",
  },
  pricing: {
    title: "pricing-title",
    toggle: (m) => `contract-toggle-${m}m`,
    offerBlock: "pricing-offer-block",
    card: (id) => `package-card-${id}`,
    badge: (id) => `package-badge-${id}`,
    fee: (id) => `package-devfee-${id}`,
    effFee: (id) => `package-effective-fee-${id}`,
    cta: (id) => `package-cta-${id}`,
    scopeNote: "pricing-scope-note",
    thirdParty: "pricing-thirdparty-note",
    maintScope: "pricing-maintscope-note",
    maintenanceCard: "maintenance-card",
    maintenanceCta: "maintenance-cta-enquiry",
    questionForm: "pricing-question-form",
  },
  contact: {
    form: "contact-form",
    name: "contact-input-name",
    email: "contact-input-email",
    phone: "contact-input-phone",
    select: "contact-select-package",
    message: "contact-input-message",
    submit: "contact-submit",
    whatsapp: "contact-whatsapp",
    success: "contact-success",
  },
  admin: {
    loginEmail: "admin-login-email",
    loginPassword: "admin-login-password",
    loginSubmit: "admin-login-submit",
    loginError: "admin-login-error",
    logout: "admin-logout",
    save: "admin-save",
    tab: (t) => `admin-tab-${t}`,
    enquiriesList: "admin-enquiries-list",
    enquiryItem: "admin-enquiry-item",
  },
};
